import { Tooltip } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

export const OverscheduleTimeTooltip = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation("bookingModule", { keyPrefix: "bookings" });

  return (
    <Tooltip
      content={
        <>
          <Typography variant="bodyBold" tag="p">
            {t("overscheduleTimeTooltip.header")}
          </Typography>
          <Typography variant="bodyRegular" tag="p">
            {t("overscheduleTimeTooltip.content")}
          </Typography>
        </>
      }
    >
      {children}
    </Tooltip>
  );
};
